module.exports = __webpack_public_path__ + "img/productBanner1.0eef1e63.png";